// extracted by css-extract-rspack-plugin
export default {"entityLink":"ZefaH","icon":"XYUJA","anchor":"_8t6Xu"};